import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2),
    },
  },
  metricsContainer: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(0),
      width: theme.spacing(20),
      height: theme.spacing(20),
    },
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  placeHolder: {
    height: '20px',
  },
  mt2: {
    marginTop: theme.spacing(2),
  },
  errorSpan: {
    fontWeight: 'bold',
    color: 'red',
  },
  paper: {
    position: 'absolute',
    width: '80%',
    height: 650,
    overflowY: 'auto',
    overflowX: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  pageControls: {
    width: '100%',
    alignContent: 'right',
  },
  recordCell: {
    paddingRight: '5px',
  },
  preline: {
    whiteSpace: 'pre-line',
  },
  metricsContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    color: '#FFF7FF',
    fontWeight: 'bold',
    height: '115px',
    cursor: 'pointer',
  },
});
